import React from 'react';
import cn from 'classnames';
import { Spinner } from '@lightspeed/flame/Spinner';

const Loading = ({ className }) => (
  <div className={cn('react-page__spinner', className)}>
    <Spinner size="2rem" color="gray-300" />
  </div>
);

export default Loading;
